import { routePermissions } from "@/constants/permission-user"

export const internalRoutesModule1 = [
  {
    path: "/internal/web-portal/dashboard",
    name: "internalPortalDashboard",
    component: () => import("@/views/portal/internal/Dashboard.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/executive-dashboard",
    name: "internalPortalExecutiveDashboard",
    component: () => import("@/views/portal/internal/ExecutiveDashboard.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Executive Dashboard",
      breadcrumb: [
        {
          text: "Executive Dashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/idc/attachment",
    name: "internalPortalAttachmentManagement",
    component: () =>
      import("@/views/portal/internal/attachment/AttachmentManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Attachment Management",
      breadcrumb: [
        {
          text: "Attachment Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/ticket",
    name: "internalTicketManagement",
    component: () => import("@/views/portal/internal/TicketManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Ticket Management",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/ticket/create-new-ticket",
    name: "internalCreateNewTicket",
    component: () =>
      import("@/views/portal/internal/ticket/TicketCreateNewTicket.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Ticket",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: false,
          to: "/internal/web-portal/ticket",
        },
        {
          text: "Create New Ticket",
          active: true,
        },
      ],
      navActiveLink: "internalTicketManagement",
    },
  },
  {
    path: "/internal/web-portal/ticket/create-new-incident",
    name: "internalCreateNewIncident",
    component: () =>
      import("@/views/portal/internal/ticket/TicketCreateNewIncident.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Incident / Job",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: false,
          to: "/internal/web-portal/ticket",
        },
        {
          text: "Create New Incident / Job",
          active: true,
        },
      ],
      navActiveLink: "internalTicketManagement",
    },
  },
  {
    path: "/internal/web-portal/ticket/:ticketId",
    name: "internalTicketDetail",
    component: () => import("@/views/portal/internal/ticket/TicketDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Ticket Detail",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: false,
          to: "/internal/web-portal/ticket",
        },
        {
          text: "Ticket Detail",
          active: true,
        },
      ],
      navActiveLink: "internalTicketManagement",
    },
  },
  {
    path: "/internal/web-portal/site-access",
    name: "internalSiteAccessManagement",
    component: () => import("@/views/portal/internal/QrAccessManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Site Access Management",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/site-access/create-new-site-access",
    name: "internalCreateNewSiteAccess",
    component: () =>
      import("@/views/portal/internal/qrAccess/QrAccessCreateNew.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Site Access",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: false,
          to: "/internal/web-portal/site-access",
        },
        {
          text: "Create New Site Access",
          active: true,
        },
      ],
      navActiveLink: "internalSiteAccessManagement",
    },
  },
  {
    path: "/internal/web-portal/site-access/dashboard",
    name: "internalSiteAccessDashboard",
    component: () =>
      import("@/views/portal/internal/qrAccess/QrAccessDashboard.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Site Access Dashboard",
      breadcrumb: [
        {
          text: "Site Access Dashboard",
          active: true,
        },
      ],
      navActiveLink: "internalSiteAccessDashboard",
    },
  },
  {
    path: "/internal/web-portal/site-access/:id",
    name: "internalSiteAccessDetail",
    component: () =>
      import("@/views/portal/internal/qrAccess/QrAccessDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Site Access Detail",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: false,
          to: "/internal/web-portal/site-access",
        },
        {
          text: "Site Access Detail",
          active: true,
        },
      ],
      navActiveLink: "internalSiteAccessManagement",
    },
  },
  {
    path: "/internal/web-portal/idc",
    name: "internalIdc",
    component: () => import("@/views/portal/internal/IdcManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "NTDC Database",
      breadcrumb: [
        {
          text: "NTDC Contract",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/idc/customer",
    name: "idcCustomer",
    component: () =>
      import("@/views/portal/internal/IdcCustomerManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "NTDC Database",
      breadcrumb: [
        {
          text: "NTDC Customer",
          active: true,
          to: "/internal/web-portal/idc/customer",
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/idc/contact",
    name: "idcContact",
    component: () => import("@/views/portal/internal/IdcContactManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "NTDC Database",
      breadcrumb: [
        {
          text: "NTDC Contract",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/idc/contract/create",
    name: "idcCreateNewContract",
    component: () =>
      import("@/views/portal/internal/idc/IdcCreateNewContract.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Contract",
      breadcrumb: [
        {
          text: "NTDC Contract",
          active: false,
          to: "/internal/web-portal/idc",
        },
        {
          text: "Create New Contract",
          active: true,
        },
      ],
      navActiveLink: "internalIdc",
    },
  },
  {
    path: "/internal/web-portal/idc/contract/:id",
    name: "idcContractAction",
    component: () =>
      import("@/views/portal/internal/idc/IdcEditAndActionContract.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Contract Detail",
      breadcrumb: [
        {
          text: "NTDC Contract",
          active: false,
          to: "/internal/web-portal/idc",
        },
        {
          text: "Contract Detail",
          active: true,
        },
      ],
      navActiveLink: "internalIdc",
    },
  },
  {
    path: "/internal/web-portal/idc/customer/create",
    name: "idcCreateCustomer",
    component: () =>
      import("@/views/portal/internal/idc/IdcCreateEditCustomer.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create Customer",
      breadcrumb: [
        {
          text: "NTDC Customer",
          active: false,
          to: "/internal/web-portal/idc/customer",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      navActiveLink: "idcCustomer",
    },
  },
  {
    path: "/internal/web-portal/idc/customer/:id",
    name: "idcEditCustomer",
    component: () =>
      import("@/views/portal/internal/idc/IdcCreateEditCustomer.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Edit Customer",
      breadcrumb: [
        {
          text: "NTDC Customer",
          active: false,
          to: "/internal/web-portal/idc/customer",
        },
        {
          text: "Edit Customer",
          active: true,
        },
      ],
      navActiveLink: "idcCustomer",
    },
  },
  {
    path: "/internal/web-portal/idc/contact-point-and-sale/create",
    name: "idcCreateContactPointOrSale",
    component: () =>
      import("@/views/portal/internal/idc/IdcCreateEditContactPointOrSale.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create Contact Point/Sale",
      breadcrumb: [
        {
          text: "NTDC Contact",
          active: false,
          to: "/internal/web-portal/idc/contact",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      navActiveLink: "idcContact",
    },
  },
  {
    path: "/internal/web-portal/idc/contact-point-and-sale/:id",
    name: "idcEditContactPointOrSale",
    component: () =>
      import("@/views/portal/internal/idc/IdcCreateEditContactPointOrSale.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Edit Contact Point/Sale",
      breadcrumb: [
        {
          text: "NTDC Contact",
          active: false,
          to: "/internal/web-portal/idc/contact",
        },
        {
          text: "Edit Contact Point",
          active: true,
        },
      ],
      navActiveLink: "idcContact",
    },
  },
  {
    path: "/internal/web-portal/ipam",
    name: "ipamManagement",
    component: () => import("@/views/portal/internal/IpamManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "IP Address Management",
      breadcrumb: [
        {
          text: "IP Address Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/report",
    name: "webPortalReport",
    component: () => import("@/views/portal/internal/Report.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Report",
      breadcrumb: [
        {
          text: "Report",
          active: true,
        },
      ],
    },
  },

  //
  // SPI 2.0
  //
  {
    path: "/internal/web-portal/escalation/template",
    name: "escalationTemplate",
    component: () =>
      import("@/views/portal/internal/escalation/EscalationTemplate.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Escalation Template",
      breadcrumb: [
        {
          text: "Escalation Template",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/escalation/events",
    name: "escalationEvents",
    component: () =>
      import("@/views/portal/internal/escalation/EscalationEvents.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Escalation Events",
      breadcrumb: [
        {
          text: "Escalation Events",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/escalation/:escalationTemplateId",
    name: "escalationTemplateDetail",
    component: () =>
      import("@/views/portal/internal/escalation/TemplateDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Template Detail",
      breadcrumb: [
        {
          text: "Escalation Template",
          active: false,
          to: "/internal/web-portal/escalation/template",
        },
        {
          text: "Template Detail",
          active: true,
        },
      ],
      navActiveLink: "escalationTemplate",
    },
  },
  {
    path: "/internal/web-portal/escalation/:escalationTemplateId/history",
    name: "escalationTemplateHistory",
    component: () =>
      import("@/views/portal/internal/escalation/TemplateHistory.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Template History",
      breadcrumb: [
        {
          text: "Escalation Template",
          active: false,
          to: "/internal/web-portal/escalation/template",
        },
        {
          text: "Template History",
          active: true,
        },
      ],
    },
  },
  {
    path: "/internal/web-portal/escalation/template/create",
    name: "createEscalationTemplate",
    component: () =>
      import("@/views/portal/internal/escalation/CreateEditTemplate.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "New Template",
      breadcrumb: [
        {
          text: "Escalation Template",
          active: false,
          to: "/internal/web-portal/escalation/template",
        },
        {
          text: "New Template",
          active: true,
        },
      ],
      navActiveLink: "escalationTemplate",
    },
  },
  {
    path: "/internal/web-portal/escalation/edit/:escalationTemplateId",
    name: "editEscalationTemplate",
    component: () =>
      import("@/views/portal/internal/escalation/CreateEditTemplate.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Edit Template",
      breadcrumb: [
        {
          text: "Escalation Template",
          active: false,
          to: "/internal/web-portal/escalation/template",
        },
        {
          text: "Edit Template",
          active: true,
        },
      ],
      navActiveLink: "escalationTemplate",
    },
  },

  //
  // FAC 2 with FOREST WORKLOAD
  //
  {
    path: "/internal/web-portal/workload",
    name: "internalWebPortalWorkload",
    component: () => import("@/views/portal/internal/Workload.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Workload",
      breadcrumb: [
        {
          text: "Workload",
          active: true,
        },
      ],
    },
  },

  //
  // INVENTORY
  //
  // {
  //   path: "/internal/web-portal/inventory",
  //   name: "internalInventory",
  //   component: () => import("@/views/portal/internal/Inventory.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Inventory",
  //     breadcrumb: [
  //       {
  //         text: "Inventory",
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  //
  // SMART HAND
  //
  // {
  //   path: "/internal/web-portal/smart-hand",
  //   name: "internalSmartHand",
  //   component: () =>
  //     import("@/views/portal/internal/SmartHandManagement.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Smart Hand Management",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: "/internal/web-portal/smart-hand/create",
  //   name: "internalSmartHandCreate",
  //   component: () =>
  //     import("@/views/portal/internal/smartHand/SmartHandCreate.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Create New Smart Hand",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: false,
  //         to: "/internal/web-portal/smart-hand",
  //       },
  //       {
  //         text: "Create New Smart Hand",
  //         active: true,
  //       },
  //     ],
  //     navActiveLink: "internalSmartHand",
  //   },
  // },
  // {
  //   path: "/internal/web-portal/smart-hand/:id",
  //   name: "internalSmartHandDetail",
  //   component: () =>
  //     import("@/views/portal/internal/smartHand/SmartHandDetail.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Smart Hand Detail",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: false,
  //         to: "/internal/web-portal/smart-hand",
  //       },
  //       {
  //         text: "Smart Hand Detail",
  //         active: true,
  //       },
  //     ],
  //     navActiveLink: "internalSmartHand",
  //   },
  // },

  //
  // PARCEL TRACKING
  //
  // {
  //   path: "/internal/web-portal/parcel-tracking",
  //   name: "internalParcelTracking",
  //   component: () => import("@/views/portal/internal/ParcelTracking.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Parcel Tracking",
  //     breadcrumb: [
  //       {
  //         text: "Parcel Tracking",
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  //
  // CROSS CONNECT
  //
  // {
  //   path: "/internal/web-portal/cross-connect",
  //   name: "internalCrossConnect",
  //   component: () =>
  //     import("@/views/portal/internal/CrossConnectManagement.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Cross Connect Management",
  //     breadcrumb: [
  //       {
  //         text: "Cross Connect Management",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: "/internal/web-portal/cross-connect/:id",
  //   name: "internalCrossConnectDetail",
  //   component: () =>
  //     import("@/views/portal/internal/xConnect/CrossConnectDetail.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Cross Connect Detail",
  //     breadcrumb: [
  //       {
  //         text: "Cross Connect Management",
  //         active: false,
  //         to: "/internal/web-portal/cross-connect",
  //       },
  //       {
  //         text: "Cross Connect Detail",
  //         active: true,
  //       },
  //     ],
  //     navActiveLink: "internalCrossConnect",
  //   },
  // },
].map((route) => {
  return {
    ...route,
    meta: {
      ...route.meta,
      type: "internal",
      permission: routePermissions[route.name],
    },
  }
})

export const externalRoutesModule1 = [
  {
    path: "/web-portal/customer-detail",
    name: "externalCustomerDetail",
    component: () => import("@/views/portal/external/CustomerDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "My Contract",
      type: "external",
      permission: "login",
      breadcrumb: [
        {
          text: "My Contract",
          active: true,
        },
      ],
    },
  },
  {
    path: "/web-portal/ticket",
    name: "externalTicketManagement",
    component: () => import("@/views/portal/external/TicketManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Ticket Management",
      type: "external",
      permission: "wpmTicketTrackingAccess",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/web-portal/ticket/create-new-ticket",
    name: "externalCreateNewTicket",
    component: () =>
      import("@/views/portal/external/ticket/TicketCreateNewTicket.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Ticket",
      type: "external",
      permission: "wpmTicketTrackingAccess",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: false,
          to: "/web-portal/ticket",
        },
        {
          text: "Create New Ticket",
          active: true,
        },
      ],
      navActiveLink: "externalTicketManagement",
    },
  },
  {
    path: "/web-portal/ticket/:ticketId",
    name: "externalTicketDetail",
    component: () => import("@/views/portal/external/ticket/TicketDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Ticket Detail",
      type: "external",
      permission: "wpmTicketTrackingAccess",
      breadcrumb: [
        {
          text: "Ticket Management",
          active: false,
          to: "/web-portal/ticket",
        },
        {
          text: "Ticket Detail",
          active: true,
        },
      ],
      navActiveLink: "externalTicketManagement",
    },
  },
  {
    path: "/web-portal/site-access",
    name: "externalSiteAccessManagement",
    component: () => import("@/views/portal/external/QrAccessManagement.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Site Access Management",
      type: "external",
      permission: "wpmQrAccessAccess",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/web-portal/site-access/create-new-site-access",
    name: "externalCreateNewSiteAccess",
    component: () =>
      import("@/views/portal/external/qrAccess/QrAccessCreateNew.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Create New Site Access",
      type: "external",
      permission: "wpmQrAccessAccess",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: false,
          to: "/web-portal/site-access",
        },
        {
          text: "Create New Site Access",
          active: true,
        },
      ],
      navActiveLink: "externalSiteAccessManagement",
    },
  },
  {
    path: "/web-portal/site-access/:id",
    name: "externalSiteAccessDetail",
    component: () =>
      import("@/views/portal/external/qrAccess/QrAccessDetail.vue"),
    meta: {
      module: "webPortal",
      pageTitle: "Site Access Detail",
      type: "external",
      permission: "wpmQrAccessAccess",
      breadcrumb: [
        {
          text: "Site Access Management",
          active: false,
          to: "/web-portal/site-access",
        },
        {
          text: "Site Access Detail",
          active: true,
        },
      ],
      navActiveLink: "externalSiteAccessManagement",
    },
  },

  //
  // SMART HAND
  //
  // {
  //   path: "/web-portal/smart-hand",
  //   name: "externalSmartHand",
  //   component: () =>
  //     import("@/views/portal/external/SmartHandManagement.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Smart Hand Management",
  //     type: "external",
  //     permission: "wpmSmartHandManagementAccess",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: "/web-portal/smart-hand/create",
  //   name: "externalSmartHandCreate",
  //   component: () =>
  //     import("@/views/portal/external/smartHand/SmartHandCreate.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Create New Smart Hand",
  //     type: "external",
  //     permission: "wpmSmartHandManagementAccess",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: false,
  //         to: "/web-portal/smart-hand",
  //       },
  //       {
  //         text: "Create New Smart Hand",
  //         active: true,
  //       },
  //     ],
  //     navActiveLink: "externalSmartHand",
  //   },
  // },
  // {
  //   path: "/web-portal/smart-hand/:id",
  //   name: "externalSmartHandDetail",
  //   component: () =>
  //     import("@/views/portal/external/smartHand/SmartHandDetail.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Smart Hand Detail",
  //     type: "external",
  //     permission: "wpmSmartHandManagementAccess",
  //     breadcrumb: [
  //       {
  //         text: "Smart Hand Management",
  //         active: false,
  //         to: "/web-portal/smart-hand",
  //       },
  //       {
  //         text: "Smart Hand Detail",
  //         active: true,
  //       },
  //     ],
  //     navActiveLink: "externalSmartHand",
  //   },
  // },

  //
  // PARCEL TRACKING
  //
  // {
  //   path: "/web-portal/parcel-tracking",
  //   name: "externalParcelTracking",
  //   component: () => import("@/views/portal/external/ParcelTracking.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Parcel Tracking",
  //     type: "external",
  //     permission: "wpmParcelTrackingAccess",
  //     breadcrumb: [
  //       {
  //         text: "Parcel Tracking",
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  //
  //  CROSS CONNECT
  //
  // {
  //   path: "/web-portal/cross-connect",
  //   name: "externalCrossConnect",
  //   component: () =>
  //     import("@/views/portal/external/CrossConnectManagement.vue"),
  //   meta: {
  //     module: "webPortal",
  //     pageTitle: "Cross Connect Management",
  //     permission: "wpmCrossConnectAccess",
  //     type: "external",
  //     breadcrumb: [
  //       {
  //         text: "Cross Connect Management",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
]
